import { Checkbox, ConfigProvider, Select } from 'antd';
import { BaseOptionType } from 'antd/es/select/index';
import React from 'react';
import { humanizedIntegrationNames } from '../../Dashboard/ActivationBlock/use-activation-steps';
import { IntegrationIcon } from '../IntegrationIcon/IntegrationIcon';
import styles from './IntegrationsSelector.module.css';

type Props = {
  availableOptions?: string[];
  selectedIntegrations: string[];
  onChange: (values: string[]) => void;
  disabled?: boolean;
};

export const IntegrationsSelector = ({
  availableOptions,
  selectedIntegrations,
  onChange,
  disabled,
}: Props) => {
  const handleChange = (values: string[]) => {
    onChange(values);
  };

  const options = Object.entries(humanizedIntegrationNames)
    .map(([type, name]) => ({
      value: type,
      label: name,
    }))
    .filter(option =>
      availableOptions ? availableOptions.includes(option.value) : true,
    );

  const renderer = (option: BaseOptionType) => {
    const { value, label } = option.data;

    return (
      <div className={styles.optionRow}>
        <ConfigProvider
          theme={{
            components: {
              Checkbox: {
                colorPrimary: 'var(--color-geekblue-6)',
              },
            },
          }}
        >
          <Checkbox checked={selectedIntegrations.includes(value)} />
        </ConfigProvider>
        <span className={styles.optionLabel}>
          <IntegrationIcon key={value} integrationType={value} isActive />
          {label}
        </span>
      </div>
    );
  };

  return (
    <Select
      style={{ width: '100%' }}
      mode="multiple"
      placeholder="Choose"
      disabled={disabled}
      value={selectedIntegrations}
      onChange={handleChange}
      options={options}
      optionRender={renderer}
      getPopupContainer={element =>
        element.parentElement ? element.parentElement : document.body
      }
    />
  );
};
